module.exports = __webpack_public_path__ + "img/ci.8557a89d.svg";